export default __webpack_public_path__ + "static/media/MiloThin.2b95e562.otf";